module.exports = __webpack_public_path__ + "img/word.2cbca9af.png";